import { render, staticRenderFns } from "./publicHeader.vue?vue&type=template&id=c21fd020&scoped=true"
import script from "./publicHeader.vue?vue&type=script&lang=js"
export * from "./publicHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21fd020",
  null
  
)

export default component.exports